import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SaudiArabiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15296'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15296)'>
				<rect
					width='20'
					height='14'
					fill='#128C4B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76172 8.40001H12.3808V8.06058C12.3808 7.57125 12.8937 7.25136 13.3331 7.46668V8.40001H14.6157C14.9593 8.40001 15.2379 8.67859 15.2379 9.02223C15.2379 9.70952 14.6808 10.2667 13.9935 10.2667H13.0474C12.6792 10.2667 12.3808 9.9682 12.3808 9.60001V9.33334H5.98631C5.81183 9.33334 5.6443 9.26494 5.51969 9.14282L4.76172 8.40001Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76172 5.73999C4.76172 5.65042 4.79777 5.56461 4.86174 5.50192L4.99498 5.37135C5.12834 5.24065 5.12834 5.0259 4.99498 4.89521L4.86174 4.76463C4.79777 4.70194 4.76172 4.61613 4.76172 4.52656V4.06661C4.76172 3.88251 4.91096 3.73328 5.09505 3.73328H5.53323C5.63312 3.73328 5.7141 3.81425 5.7141 3.91414C5.7141 4.1042 5.9697 4.16564 6.05607 3.99634L6.12919 3.85304C6.16669 3.77954 6.24223 3.73328 6.32474 3.73328H7.38553C7.51439 3.73328 7.61886 3.83774 7.61886 3.96661C7.61886 4.09548 7.51439 4.19994 7.38553 4.19994H6.89981C6.77095 4.19994 6.66648 4.30441 6.66648 4.43328C6.66648 4.56214 6.77095 4.66661 6.89981 4.66661H7.28553C7.46962 4.66661 7.61886 4.81585 7.61886 4.99994V6.19994C7.61886 6.38404 7.46962 6.53328 7.28553 6.53328H6.99981C6.81572 6.53328 6.66648 6.38404 6.66648 6.19994V5.83804C6.66648 5.70654 6.77548 5.59994 6.90698 5.59994C7.03585 5.59994 7.14267 5.49548 7.14267 5.36661C7.14267 5.23774 7.0382 5.13328 6.90934 5.13328H6.52362C6.33953 5.13328 6.19029 5.28251 6.19029 5.46661V6.29518C6.19029 6.42668 6.08369 6.53328 5.95219 6.53328C5.8207 6.53328 5.7141 6.42668 5.7141 6.29518V5.83804C5.7141 5.70654 5.6075 5.59994 5.476 5.59994C5.34451 5.59994 5.23791 5.70654 5.23791 5.83804V6.29518C5.23791 6.42668 5.13131 6.53328 4.99981 6.53328C4.86832 6.53328 4.76172 6.42668 4.76172 6.29518V5.73999Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3809 5.73999C12.3809 5.65042 12.4169 5.56461 12.4809 5.50192L12.6141 5.37135C12.7475 5.24065 12.7475 5.0259 12.6141 4.89521L12.4809 4.76463C12.4169 4.70194 12.3809 4.61613 12.3809 4.52656V4.06661C12.3809 3.88251 12.5301 3.73328 12.7142 3.73328H13.1524C13.2523 3.73328 13.3332 3.81425 13.3332 3.91414C13.3332 4.1042 13.5888 4.16564 13.6752 3.99634L13.7483 3.85304C13.7858 3.77954 13.8614 3.73328 13.9439 3.73328H15.0047C15.1335 3.73328 15.238 3.83774 15.238 3.96661C15.238 4.09548 15.1335 4.19994 15.0047 4.19994H14.519C14.3901 4.19994 14.2856 4.30441 14.2856 4.43328C14.2856 4.56214 14.3901 4.66661 14.519 4.66661H14.9047C15.0888 4.66661 15.238 4.81585 15.238 4.99994V6.19994C15.238 6.38404 15.0888 6.53328 14.9047 6.53328H14.619C14.4349 6.53328 14.2856 6.38404 14.2856 6.19994V5.83804C14.2856 5.70654 14.3946 5.59994 14.5261 5.59994C14.655 5.59994 14.7618 5.49548 14.7618 5.36661C14.7618 5.23774 14.6573 5.13328 14.5285 5.13328H14.1428C13.9587 5.13328 13.8094 5.28251 13.8094 5.46661V6.29518C13.8094 6.42668 13.7028 6.53328 13.5713 6.53328C13.4398 6.53328 13.3332 6.42668 13.3332 6.29518V5.83804C13.3332 5.70654 13.2266 5.59994 13.0951 5.59994C12.9636 5.59994 12.857 5.70654 12.857 5.83804V6.29518C12.857 6.42668 12.7505 6.53328 12.619 6.53328C12.4875 6.53328 12.3809 6.42668 12.3809 6.29518V5.73999Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4294 4.43109C11.4294 4.56116 11.355 4.73953 11.2575 4.83509L11.1251 4.9648C11.0302 5.05785 11.0276 5.20619 11.1251 5.30175L11.2575 5.43147C11.3524 5.52451 11.4294 5.69983 11.4294 5.83546V6.29776C11.4294 6.42783 11.3275 6.53328 11.1891 6.53328H10.7174C10.5846 6.53328 10.477 6.43339 10.477 6.29776V5.83546C10.477 5.70539 10.4331 5.68608 10.3666 5.81641L10.1113 6.31681C10.0503 6.43636 9.88874 6.53328 9.76494 6.53328H8.80817C8.67788 6.53328 8.57227 6.42504 8.57227 6.29994C8.57227 6.17108 8.67419 6.06661 8.81259 6.06661H9.28432C9.41705 6.06661 9.52465 5.95837 9.52465 5.83328C9.52465 5.70441 9.42273 5.59994 9.28432 5.59994H8.81259C8.67986 5.59994 8.57227 5.49958 8.57227 5.37105V3.96217C8.57227 3.83575 8.67419 3.73328 8.81259 3.73328H9.28432C9.41705 3.73328 9.52465 3.83316 9.52465 3.9688V4.43109C9.52465 4.56116 9.4142 4.66661 9.28655 4.66661C9.15505 4.66661 9.04846 4.77485 9.04846 4.89994C9.04846 5.02881 9.15038 5.13328 9.28878 5.13328H9.76051C9.89324 5.13328 10.0008 5.02342 10.0008 4.90209V3.96446C10.0008 3.83678 10.1113 3.73328 10.2389 3.73328C10.3704 3.73328 10.477 3.83316 10.477 3.9688V4.43109C10.477 4.56116 10.5875 4.66661 10.7151 4.66661C10.8466 4.66661 10.9532 4.56673 10.9532 4.43109V3.9688C10.9532 3.83872 11.0637 3.73328 11.1913 3.73328C11.3228 3.73328 11.4294 3.83316 11.4294 3.9688V4.43109Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default SaudiArabiaFlagIcon;
